import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveInstance = (state, instance) => state.some((item) => item.transitionId === instance.transitionId);

export const statusTransitionsSlice = createSlice({
  name: 'statusTransitions',
  initialState: initialState,
  reducers: {
    clearStatusTransitions: () => {
      return initialState;
    },

    addStatusTransition: (state, action) => {
      const instance = action.payload;
      if (haveInstance(state, instance)) {
        return state;
      } else {
        return state.concat(instance);
      }
    },

    addStatusTransitions: (state, action) => {
      let transitions = state;
      action.payload.forEach((instance) => {
        if (!haveInstance(state, instance)) {
          transitions = [...transitions, instance];
        }
      });

      return transitions;
    },
  },
});

export const { clearStatusTransitions, addStatusTransition, addStatusTransitions } = statusTransitionsSlice.actions;

export default statusTransitionsSlice.reducer;
